import React, {useEffect, useState} from "react";
import { useParams } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {Text} from "../../../../../../common/text";
import {ModalConfirmStatus} from "../modal";
import {StyledFacebookMessageConfirmOrderEdit} from "./_styled";
import useFacebookMessageConfirmOrder from "../../hooks/useFacebookMessageConfirmOrder";
import { MessageConfirm} from "./contentMessage";
import {Switch} from "../../../../../../common/switch";




export const EditContent=(props)=>{
    const {t}= useTranslation()
    const params = useParams();
    const {data, methods} = useFacebookMessageConfirmOrder()
    const {confirmStatus} = data.modal
    const{list, content_message, samples, status, validate, reset}= data.detail
    useEffect(() => {
        methods.fetchDetail(params.pageId)
    }, [])
    return (
        <StyledFacebookMessageConfirmOrderEdit {...props}>
            <div>
                <MessageConfirm
                    header={'contentMessage'}
                    description={'contentMessageDescription'}
                    sample={samples}
                    onResetDefault={methods?.onReset}
                    message={content_message}
                    onChangeMessage={methods.onChangeMessage}
                    onBlurMessage={methods.onBlurMessage}
                    validateMessage={validate}
                    placeHolder={'typeToCreateMessage'}
                    resetDefault={reset}
                    list={list}
                />
            </div>
            <div className={'facebook-message-confirm-edit_content'}>
                <Switch
                    checked={+status === 1 ? true : false}
                    onChange={methods.onChangeMessageStatus}
                />
                <Text>{t('general_active_or_inactive')}</Text>
            </div>

        </StyledFacebookMessageConfirmOrderEdit>
    )
}